import { InjectedStyledComponent } from '../../../../../../shared/InjectedStyledComponent.js';
import {
	GROUP_HEADER_CATEGORY_KEY,
	GROUP_HEADER_COMPONENT_KEY,
	GROUP_HEADER_PARENT_COMPONENT_KEY,
} from '../GroupHeader.meta.js';

export default InjectedStyledComponent('div', GROUP_HEADER_CATEGORY_KEY, GROUP_HEADER_PARENT_COMPONENT_KEY, [
	GROUP_HEADER_COMPONENT_KEY,
	'toggleButtonWrapper',
]);
